export default "<p>autority-view works!</p>\n"